import axios from 'axios'

const URL_PATH = '/ata-registro-preco/api/public/relatorios/controle-adesoes'

class ControleAdesoesApiClient {
	async baixarRelatorioControleAdesoes(idDocumento) {
		return await axios.get(`${URL_PATH}/${idDocumento}/baixar`, {
			responseType: 'arraybuffer',
		})
	}
}

export default new ControleAdesoesApiClient()
